export {};
declare global {
    interface Array<T> {
        extractNumbers(): number[];
    }
}

Array.prototype.extractNumbers = function() {
    const res: number[] = [];
    for (const i of this) {
        const clearedStr = String(i).replace(/[^\d.-]/g, '').trim();
        if (clearedStr.length > 0) {
            res.push(Number(clearedStr));
        }
    }
    return res;
};

